import type { FC } from "react";
import { useTranslation } from "react-i18next";
import type { ThemeSlotPropsMap } from "@huub-web/ui/contexts/ThemeSlotContext";

import { RandstadBanner } from "./RandstadBanner";

type Props = ThemeSlotPropsMap["pageHeading"];

const IMAGE_MAP: Record<string, string> = {
  advice:
    "https://www.randstad.nl/binaries/cardImageDesktopRetina/content/gallery/randstad/card-images/campagnes/randstad-professional.jpg",
  documentsOutgoing:
    "https://www.randstad.nl/binaries/cardImageDesktopRetina/content/gallery/randstad/card-images/campagnes/randstad-enterprise.jpg",
  documentsIncoming:
    "https://www.randstad.nl/binaries/cardImageDesktopRetina/content/gallery/randstad/card-images/campagnes/randstad-enterprise.jpg",
  interestRates:
    "https://www.randstad.nl/binaries/cardImageDesktopRetina/content/gallery/randstad/card-images/randstad-professional-afbeeldingen/fotografie-website-professional-9.svg",
  maximumMortgage:
    "https://www.randstad.nl/binaries/content/gallery/randstad/afbeeldingen/randstad-professional-afbeeldingen/fotografie-website-professional-8.svg/fotografie-website-professional-8.svg/randstad%3AdesktopLarge",
  orientation:
    "https://www.randstad.nl/binaries/content/gallery/randstad/illustraties/banner/randstad-professional-afbeeldingen/webp-rm_025-tech.jpg",
};

export const RandstadPageHeading: FC<Props> = ({ scope }) => {
  const { t } = useTranslation();

  return (
    <RandstadBanner
      title={t(`${scope}Heading.title`)}
      description={t(`${scope}Heading.description`)}
      imageSrc={IMAGE_MAP[scope] ?? ""}
    />
  );
};
